import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import WatchlistLayer from "../../components/Trading/WatchlistLayer";

const WatchlistPage = () => {
  return (
    <MasterLayout>
      <WatchlistLayer />
    </MasterLayout>
  );
};

export default WatchlistPage;
